export function 税額計算関数(課税所得: number): number {
    let 税率: number = 0;
    let 控除額: number = 0;

    // 速算表に基づいた条件分岐
    if (課税所得 <= 1950000) {
      税率 = 0.05;
      控除額 = 0;
    } else if (課税所得 <= 3300000) {
      税率 = 0.10;
      控除額 = 97500;
    } else if (課税所得 <= 6950000) {
      税率 = 0.20;
      控除額 = 427500;
    } else if (課税所得 <= 9000000) {
      税率 = 0.23;
      控除額 = 636000;
    } else if (課税所得 <= 18000000) {
      税率 = 0.33;
      控除額 = 1536000;
    } else if (課税所得 <= 40000000) {
      税率 = 0.40;
      控除額 = 2796000;
    } else {
      // 4000万円超
      税率 = 0.45;
      控除額 = 4796000;
    }
  
    return Math.max(0, 課税所得 * 税率 - 控除額);
  }
  
  export function 復興所得税考慮関数(input: number): number {
    const 復興特別所得税: number = 0.021;
    return input * (1 + 復興特別所得税);
  }